export default "__VITE_ASSET__BpSONx8E__"